import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed, watchEffect } from 'vue';
import { useLayoutStoreHook } from '@/store/modules/layout';
import LayoutHeader from './components/layout-header.vue';
import LayoutAside from './components/layout-aside.vue';
import LayoutBody from './components/layout-body.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutStore = useLayoutStoreHook();

const showAside = computed(() => {
  const { layout } = layoutStore;
  if (layout === 'horizontal') {
    return false;
  }
  return true;
});

const containerClass = computed(() => {
  const { layout, themeStyle, themeColorMap } = layoutStore;
  return {
    'fd-main-container': true,
    [themeStyle]: true,
    [`fd-layout-${layout}`]: true,
  };
});

watchEffect(() => {
  const { layout, themeStyle, theme } = layoutStore;
  const attributes = { layout, themeStyle };
  document.documentElement.setAttribute('theme', theme);
  Object.keys(attributes).forEach((k) => {
    type Keys = keyof typeof attributes;
    const key = k as Keys;
    document.body.setAttribute(k, attributes[key]);
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(containerClass))
  }, [
    _createVNode(LayoutHeader),
    (_unref(showAside))
      ? (_openBlock(), _createBlock(LayoutAside, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(LayoutBody)
  ], 2))
}
}

})